// src/pages/CartPage.js
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeFromCart, updateQuantity } from "../../slice/cartSlice";

const CartPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cartItems = useSelector((state) => state.cart.cartItems || []);
  const user = useSelector((state) => state.user.response);

  console.log("User data from store:", user);
  console.log("Cart Items:", cartItems);

  const totalAmount = cartItems.reduce(
    (sum, item) => sum + (item.fees || item.fee || 0) * item.quantity,
    0
  );

  const handlePlaceOrder = async () => {
    if (!user || !user.id) {
      alert("Please login first to place your order.");
      navigate("/login");
      return;
    }

    if (cartItems.length === 0) {
      alert("Your cart is empty!");
      return;
    }

    try {
      const baseURL = process.env.REACT_APP_API_BASE_URL;
      const orderPayload = {
        orderID: `ORD-${Date.now()}`,
        customerID: user.id,
        totalAmount,
        shippingAddress: user.address || "N/A",
        phoneNumber: user.phone || "N/A",
        paymentMethod: "COD",
        item_details: cartItems.map((item) => ({
          id: item.id || item._id,
          qty: item.quantity,
        })),
      };

      console.log("Sending order:", orderPayload);

      const response = await fetch(`${baseURL}/order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderPayload),
      });

      const result = await response.json();

      console.log("Order API response:", result);

      if (!response.ok) {
        throw new Error(result.message || "Order failed");
      }

      dispatch(removeFromCart()); // clear cart
      alert("Order placed successfully!");
    } catch (err) {
      console.error("Order failed:", err);
      alert("Something went wrong while placing your order.");
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-center mb-10 text-[#fc3c04]">My  <span className="text-[#345bf3]">Cart</span></h1>

      {cartItems.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-gray-500 text-xl">Your cart is empty.</p>
        </div>
      ) : (
        <>
          <div className="space-y-6">
            {cartItems.map((course) => (
              <div
                key={course._id || course.id}
                className="flex flex-col md:flex-row bg-white shadow-lg rounded-xl overflow-hidden border border-gray-100"
              >
                <div className="md:w-1/3 w-full h-60 md:h-auto">
                  <img
                    src={
                      course?.image
                        ? `${process.env.REACT_APP_BACKEND_URL_REL}${course.image}`
                        : "/default-course.jpg"
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                    
                    }}
                    alt={course?.title || "Course Image"}
                    className="w-full h-full object-cover rounded-md"
                  />
                </div>

                <div className="md:w-2/3 w-full p-6 flex flex-col justify-between">
                  <div>
                    <h2 className="text-2xl font-semibold text-blue-700 mb-2">{course.title}</h2>
                    <p className="text-gray-600 mb-1">
                      <span className="font-medium">Category:</span> {course.category}
                    </p>
                    <p className="text-gray-600 mb-4">
                      <span className="font-medium">Fee:</span> ₹{(course.fees || course.fee).toLocaleString()}
                    </p>
                  </div>

                  <div className="flex items-center gap-3 flex-wrap">
                    <button
                      disabled={course.quantity <= 1}
                      onClick={() =>
                        dispatch(updateQuantity({ id: course._id || course.id, delta: -1 }))
                      }
                      className="bg-gray-200 px-3 py-1 rounded text-lg font-bold hover:bg-gray-300 disabled:opacity-50"
                    >
                      -
                    </button>
                    <span className="text-lg font-semibold">{course.quantity}</span>
                    <button
                      onClick={() =>
                        dispatch(updateQuantity({ id: course._id || course.id, delta: 1 }))
                      }
                      className="bg-gray-200 px-3 py-1 rounded text-lg font-bold hover:bg-gray-300"
                    >
                      +
                    </button>

                    <button
                      onClick={() => dispatch(removeFromCart(course._id || course.id))}
                      className="ml-auto text-red-600 hover:text-red-800 text-sm font-medium"
                    >
                      Remove
                    </button>
                  </div>

                  <div className="mt-4 text-right text-lg font-semibold text-blue-800">
                    Total: ₹{((course.fees || course.fee) * course.quantity).toLocaleString()}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center mt-10 p-6 bg-gray-50 border rounded-lg shadow-sm">
            <div className="text-2xl font-bold text-blue-900 mb-4 md:mb-0">
              Grand Total: ₹{totalAmount.toLocaleString()}
            </div>

            <button
              onClick={handlePlaceOrder}
              className="bg-blue-700 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-blue-800 transition"
            >
              Proceed to Checkout
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;
